import React, { useState } from "react";
import { Features } from "../../components/Features";
import style from "./style.module.css";
import { SingleFaceSwapFAQ } from "../../components/faqs/index";
import DownloadDetailSection from "../../components/downloadDetailSection/index";
import Review from "../../components/Review";
import { SingleFaceSwapHeroSection } from "../../components/HeroSection";
import Footer from "../../components/Footer";
import ScrollToTop from "../../components/scrollToTop/index";
import { Container } from "@mui/material";
import InstallSection from "../../components/installSection/index";
import { checkCompletedImage, updateImage } from "../../services/api/effects";
// import { DecryptImage } from "../../constants/DecryptImage";
import { FaDownload, FaShareAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import { v4 as uuidv4 } from "uuid";
import { SingleFaceSwapGuide } from "../../components/sections/FaceSwapGuide";
import { WhoCanUseSnapToon } from "../../components/sections/WhoCanUseSnapToon";
import { SingleFaceSwapBenefits } from "../../components/sections/SnapToonBenefits";
import CustomProgressBar from "../../components/CustomProgressBar";
import toastFile from "../../services/toastFile";
import { AutoAwesome, FaceRetouchingNatural, PhotoCamera } from "@mui/icons-material";
import MoreAppsSection from "../../components/MoreAppsSection";

const FaceSwap: React.FC = () => {
  const [progress, setProgress] = useState<number>(0);
  const [originalImage, setOriginalImage] = useState<string | null>(null);
  const [faceImage, setFaceImage] = useState<string | null>(null);
  const [swapInProgress, setSwapInProgress] = useState<boolean>(false);
  const [dragOverOriginal, setDragOverOriginal] = useState<boolean>(false);
  const [dragOverFace, setDragOverFace] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [swappedImage, setSwappedImage] = useState<string>(
    "https://snaptoon-development.s3.eu-north-1.amazonaws.com/snaptoon_web/initial_image.jpg"
  );
  const [convertedImage, setConvertedImage] = useState<string | null>(null);
  const [isTapped, setIsTapped] = useState<boolean>(false);
  const [isSwappingFailed, setIsSwappingFailed] = useState<boolean>(false);
  let failureInterval: ReturnType<typeof setTimeout> | undefined;
  const fetchFSImageData = async (FSResp: string) => {
    let payload = {
      image_id: FSResp,
    };
    try {
      const res = await checkCompletedImage(payload);
      console.log({ res: res.data.data?.is_found });
      if (res?.data?.status === 400) {
        toastFile("error", "Face Swap Failed! Please try with another image.");
        setSwapInProgress(false);
      } else if (res.data.data?.is_found) {
        let originalImg = "";
        try {
          // originalImg = DecryptImage(res?.data?.data?.img);
          originalImg = `data:image/jpeg;base64,${res?.data?.data?.img}`;

          // Animate progress to 100% over 2 seconds
          const currentProgress = progress;
          const increment = (100 - currentProgress) / 20;
          let step = 0;

          const progressInterval = setInterval(() => {
            step++;
            setProgress((prev) => Math.min(prev + increment, 100));

            if (step >= 20) {
              clearInterval(progressInterval);
              setTimeout(() => {
                toastFile("success", "Face Swap Completed Successfully!");
                setConvertedImage(originalImg);
                setSwapInProgress(false);
              }, 100);
            }
          }, 100);
        } catch (e) {
          console.log(e);
        }

      } else {
        setTimeout(() => {
          fetchFSImageData(FSResp);
        }, 3000);
      }
    } catch (error) {
      console.log("API error:", error);
      toastFile("error", "Face Swap Failed! Please try with another image.");
      setSwapInProgress(false);
    }
  };

  const applyEffect = async () => {
    if (!originalImage || !faceImage) return;
    let payload = {
      img: originalImage.replace(/^data:image\/[a-z]+;base64,/, ""),
      target_img: faceImage.replace(/^data:image\/[a-z]+;base64,/, ""),
    };
    try {
      const res = await updateImage(payload);
      if (res?.data?.status === 200) {
        fetchFSImageData(res?.data?.data?.id);
      } else {
        setSwapInProgress(false);
      }
    } catch (e) {
      setSwapInProgress(false);
    }
  };

  const startFaceSwap = () => {
    setIsSwappingFailed(false);
    // if(failureInterval){
    //   clearTimeout(failureInterval);
    // }
    // failureInterval = setTimeout(() => {
    //   setIsSwappingFailed(true);
    //   setSwapInProgress(false)
    // }, 180000);
    setProgress(0);
    setSwapInProgress(true);
    applyEffect();
  };

  const handleImageUpload = (
    e: React.ChangeEvent<HTMLInputElement>,
    setImage: React.Dispatch<React.SetStateAction<string | null>>
  ) => {
    setIsSwappingFailed(false);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImage(reader.result as string);
      }
    };
    if (e?.target?.files?.[0]) {
      reader.readAsDataURL(e.target.files[0]);
      console.log("Uploaded file:", e.target.files[0].name);
    }
  };

  const handleDrop = (
    e: React.DragEvent<HTMLLabelElement>,
    setImage: React.Dispatch<React.SetStateAction<string | null>>,
    setDragOver: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    e.preventDefault();
    setDragOver(false);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImage(reader.result as string);
      }
    };
    if (e?.dataTransfer?.files?.[0]) {
      reader.readAsDataURL(e.dataTransfer.files[0]);
      console.log("Dropped file:", e.dataTransfer.files[0].name);
    }
  };

  const handleDownload = () => {
    if (!convertedImage) return;
    var imageUid = uuidv4();
    const link = document.createElement("a");
    link.href = convertedImage;
    link.download = `swaptoon_buoyancy_${imageUid}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleShare = async () => {
    if (!convertedImage) return;

    try {
      if (navigator.share) {
        try {
          await navigator.share({
            files: [
              new File([base64ToBlob(convertedImage)], "shared_image.png", {
                type: "image/png",
              }),
            ],
            title: "Check out this image!",
            text: "I wanted to share this cool image with you.",
          });
          console.log("Image shared successfully");
        } catch (error) {
          console.log("Error sharing the image:", error);
        }
      } else {
        console.log("Web Share API is not supported in your browser.");
      }
    } catch (error) {
      console.log("Error sharing:", error);
    }
  };

  const base64ToBlob = (base64: string): Blob => {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: "image/png" });
  };

  const handleImageTap = () => {
    if (window.screen.width <= 768) {
      setIsTapped((prev) => !prev);
    }
  };

  return (
    <>
      <ScrollToTop />
      <div className="flex flex-1">
        <div className="hidden lg:block w-1/5 p-4 mt-14">
          {/* Advertise sectin */}
          <ins
            className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-3821089660320367"
            data-ad-slot="7381608051"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></ins>
        </div>
        <div className="w-full lg:w-3/5 p-4">
          <>
            <div className="d-flex flex-column align-items-center justify-center mb-4 mt-24 text-center hero-ambient-glow">
              <div className="gradient-badge mb-3 px-4 py-2 text-indigo-300 font-semibold text-sm d-inline-flex align-items-center gap-2">
                <AutoAwesome sx={{ fontSize: 18, color: "#c084fc" }} /> Instant AI Face Swap
              </div>
              <h1 className="gradient-text" style={{ fontSize: "2.6rem", fontWeight: 800, letterSpacing: "-0.5px" }}>
                SwapToon – AI Face Swap App for Fun & Creativity
              </h1>
            </div>
            <div className="d-flex justify-center mb-5 text-center">
              <div className="glass-panel-hero p-4 p-md-4" style={{ borderRadius: "24px", maxWidth: "900px" }}>
                <h2 style={{ fontSize: "1.5rem", fontWeight: 700, color: "#f8fafc", marginBottom: "10px" }}>
                  Swap Faces Instantly with AI-Powered Face Swap Technology!
                </h2>
                <p style={{ color: "#94a3b8", fontSize: "16px", lineHeight: 1.6, margin: 0 }}>
                  Ever wondered how you’d look with someone else’s face? Or how fun it would be to swap faces with your favorite celebrity, cartoon character, or even a pet? With SwapToon, you can do just that! Our advanced AI face swap technology lets you create hilarious, realistic, and high-quality photo transformations in just a few taps.
                </p>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="align-items-center col-12 col-lg-8 d-flex justify-content-center">
                <div
                  className="glass-panel-hero p-4 p-md-5 w-100 d-flex flex-column align-items-center mb-4"
                  style={{ borderRadius: "24px" }}
                >
                  <div className="row w-100 justify-content-center g-4">
                    <div className="align-items-center col-12 col-md-6 d-flex flex-column upload-box-wrapper">
                      <label className="font-bold text-lg mb-3 d-flex align-items-center gap-2" style={{ color: "#e2e8f0" }}>
                        <PhotoCamera sx={{ fontSize: 20, color: "#818cf8" }} /> Target Image
                      </label>
                      <label
                        htmlFor="originalUpload"
                        className={`p-3 rounded-2xl w-full flex flex-col justify-center items-center cursor-pointer transition-all ${originalImage || dragOverOriginal
                          ? "border-2 border-indigo-400 bg-indigo-950/50 shadow-lg shadow-indigo-500/20"
                          : "border-2 border-dashed border-slate-600 hover:border-indigo-400 bg-slate-800/40 hover:bg-slate-800/70"
                          }`}
                        style={{ height: "220px", width: "100%", maxWidth: "240px", borderRadius: "18px" }}
                        onDragOver={(e) => {
                          e.preventDefault();
                          setDragOverOriginal(true);
                        }}
                        onDragLeave={() => setDragOverOriginal(false)}
                        onDrop={(e) =>
                          handleDrop(e, setOriginalImage, setDragOverOriginal)
                        }
                      >
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          id="originalUpload"
                          onChange={(e) =>
                            handleImageUpload(e, setOriginalImage)
                          }
                        />
                        <div
                          className="align-items-center cursor-pointer d-flex justify-content-center text-center w-full h-full"
                        >
                          {originalImage ? (
                            <img
                              src={originalImage}
                              alt="Original"
                              className="w-full h-full object-cover"
                              style={{ borderRadius: "12px" }}
                            />
                          ) : (
                            <div className="d-flex flex-column align-items-center gap-2 p-2">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle"
                                style={{
                                  width: 54,
                                  height: 54,
                                  background: "rgba(99, 102, 241, 0.15)",
                                  border: "1px solid rgba(165, 180, 252, 0.3)",
                                }}
                              >
                                <PhotoCamera
                                  sx={{
                                    fontSize: 32,
                                    color: "#a5b4fc"
                                  }}
                                />
                              </div>
                              <span style={{ color: "#a5b4fc", fontSize: "0.9rem", fontWeight: 700 }}>
                                Upload Target Photo
                              </span>
                              <span style={{ color: "#64748b", fontSize: "0.75rem" }}>
                                Drag & drop or browse
                              </span>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                    <div className="align-items-center col-12 col-md-6 d-flex flex-column upload-box-wrapper">
                      <label className="font-bold text-lg mb-3 d-flex align-items-center gap-2" style={{ color: "#e2e8f0" }}>
                        <FaceRetouchingNatural sx={{ fontSize: 20, color: "#c084fc" }} /> Source Face
                      </label>
                      <label
                        htmlFor="faceUpload"
                        className={`p-3 rounded-2xl w-full flex flex-col justify-center items-center cursor-pointer transition-all ${faceImage || dragOverFace
                          ? "border-2 border-purple-400 bg-purple-950/50 shadow-lg shadow-purple-500/20"
                          : "border-2 border-dashed border-slate-600 hover:border-purple-400 bg-slate-800/40 hover:bg-slate-800/70"
                          }`}
                        style={{ height: "220px", width: "100%", maxWidth: "240px", borderRadius: "18px" }}
                        onDragOver={(e) => {
                          e.preventDefault();
                          setDragOverFace(true);
                        }}
                        onDragLeave={() => setDragOverFace(false)}
                        onDrop={(e) =>
                          handleDrop(e, setFaceImage, setDragOverFace)
                        }
                      >
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          id="faceUpload"
                          onChange={(e) => handleImageUpload(e, setFaceImage)}
                        />
                        <div
                          className="align-items-center cursor-pointer d-flex justify-content-center text-center w-full h-full"
                        >
                          {faceImage ? (
                            <img
                              src={faceImage}
                              alt="Face"
                              className="w-full h-full object-cover"
                              style={{ borderRadius: "12px" }}
                            />
                          ) : (
                            <div className="d-flex flex-column align-items-center gap-2 p-2">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle"
                                style={{
                                  width: 54,
                                  height: 54,
                                  background: "rgba(192, 132, 252, 0.15)",
                                  border: "1px solid rgba(192, 132, 252, 0.3)",
                                }}
                              >
                                <FaceRetouchingNatural
                                  sx={{
                                    fontSize: 32,
                                    color: "#c084fc",
                                  }}
                                />
                              </div>
                              <span style={{ color: "#c084fc", fontSize: "0.9rem", fontWeight: 700 }}>
                                Upload Swap Face
                              </span>
                              <span style={{ color: "#64748b", fontSize: "0.75rem" }}>
                                Drag & drop or browse
                              </span>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                  </div>
                  {swapInProgress ? (
                    <div className="w-100 mt-4">
                      <CustomProgressBar swapInProgress={swapInProgress} progress={progress} setProgress={setProgress} />
                    </div>
                  ) : (
                    <button
                      className="btn-gradient mt-4 px-5 py-3 text-white disabled:opacity-50 d-flex align-items-center gap-2"
                      disabled={!originalImage || !faceImage || swapInProgress}
                      onClick={startFaceSwap}
                      style={{ fontSize: "1.1rem", cursor: (!originalImage || !faceImage) ? "not-allowed" : "pointer" }}
                    >
                      <AutoAwesome sx={{ fontSize: 22 }} /> Start Face Swapping
                    </button>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-4 d-flex d-lg-block justify-content-center mt-4 mt-lg-0">
                <div
                  className="glass-panel-hero p-3 d-flex justify-content-center position-relative w-100 overflow-hidden"
                  style={{ borderRadius: "24px", minHeight: "300px" }}
                >
                  {convertedImage ? (
                    <motion.div
                      className="position-relative"
                      style={{ width: "100%", height: "100%" }}
                      onHoverStart={() => setIsHovered(true)}
                      onHoverEnd={() => setIsHovered(false)}
                      onClick={handleImageTap}
                    >
                      <motion.img
                        src={convertedImage}
                        alt="Swapped"
                        className="max-h-full rounded"
                        style={{ width: "100%", height: "auto" }}
                        initial={{ opacity: 1 }}
                        animate={{ opacity: isHovered || isTapped ? 0.5 : 1 }}
                      />

                      {(isHovered || isTapped) && (
                        <div
                          className="position-absolute top-0 left-0 w-100 h-100"
                          style={{
                            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black color
                            borderRadius: "inherit",
                            zIndex: 1,
                          }}
                        ></div>
                      )}
                      {/* Hover Actions */}
                      {(isHovered || isTapped) && (
                        <div
                          className="position-absolute top-50 start-50 translate-middle d-flex gap-3"
                          style={{ pointerEvents: "none", zIndex: 2 }}
                        >
                          {/* Download Icon */}
                          <motion.button
                            className="btn btn-primary rounded-circle p-2"
                            whileHover={{ scale: 1.2 }}
                            whileTap={{ scale: 0.9 }}
                            onClick={handleDownload}
                            style={{ pointerEvents: "auto" }}
                          >
                            <FaDownload size={20} />
                          </motion.button>

                          {/* Share Icon */}
                          <motion.button
                            className="btn btn-success rounded-circle p-2"
                            whileHover={{ scale: 1.2 }}
                            whileTap={{ scale: 0.9 }}
                            onClick={handleShare}
                            style={{ pointerEvents: "auto" }}
                          >
                            <FaShareAlt size={20} />
                          </motion.button>
                        </div>
                      )}
                    </motion.div>
                  ) : (
                    <img
                      src={swappedImage}
                      alt="face_swap_image"
                      style={{ width: "100%", height: "100%" }}
                    />
                  )}
                </div>
              </div>
            </div>
          </>
        </div>
        <div className="hidden lg:block w-1/5 p-4 mt-14">
          {/* Advertise sectin */}
          <ins
            className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-3821089660320367"
            data-ad-slot="7381608051"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></ins>
        </div>
      </div>
      <div>
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-3821089660320367"
          data-ad-slot="7635816975"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
      <div>
        <SingleFaceSwapHeroSection />
      </div>
      <Container>
        {/* <div className="d-flex justify-center">
          <div
            style={{ width: 970, height: 90, border: "1px solid red" }}
          ></div>
        </div> */}
      </Container>
      <div>
        <Features />
      </div>
      <div>
        <SingleFaceSwapGuide />
      </div>
      <div>
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-3821089660320367"
          data-ad-slot="7635816975"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
      <div>
        <WhoCanUseSnapToon />
      </div>
      <div>
        <DownloadDetailSection />
      </div>
      <div>
        <SingleFaceSwapBenefits />
      </div>
      <div>
        <Review />
      </div>
      <div>
        <InstallSection />
      </div>
      <div className={style.faq_section}>
        <SingleFaceSwapFAQ />
      </div>
      <div>
        <MoreAppsSection />
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

export default FaceSwap;
